import React from 'react';

const Subtitle = ({ children }) => (
  <h2 className="Footer-subtitle">{children}</h2>
);

export default Subtitle;



// WEBPACK FOOTER //
// ./src/components/Footer/subtitle.js